export function clearText(
  ctxInside: CanvasRenderingContext2D,
  inside: HTMLCanvasElement,
  width: number,
  index: number,
) {
  // Clear the canvas
  ctxInside.clearRect(width * index, 0, width, inside.height);
  ctxInside.beginPath();
  ctxInside.rect(width * index, 0, width, inside.height);
  ctxInside.fillStyle = "#fff";
  ctxInside.fill();
}

function toggleItalic(font: string, on: boolean): string {
    if (font.includes("italic")) {
        if (on) { return font; }
        else {
            return font.replace("italic ", "");
        }
    }

    if (on) {
        return "italic " + font
    } else {
        return font
    }
}

function toggleBold(font: string, on: boolean): string {
    if (font.includes("bold")) {
        if (on) { return font; }
        else {
            return font.replace("bold ", "");
        }
    }

    if (on) {
        return "bold " + font
    }
    else {
        return font
    }
}

export function drawText(
  ctxInside: CanvasRenderingContext2D,
  inside: HTMLCanvasElement,
  text: string,
  columnIndex: number,
) {
  if (!ctxInside || !inside) {
    console.warn("Canvas not ready for rendering");
    return;
  }

  // Remove this later: draw a line at 50% of the height, to see where the 'cut line' would be and whether text intersects it
  // ctxInside.beginPath();
  // ctxInside.strokeStyle = "#f00";
  // ctxInside.lineWidth = 25;
  // ctxInside.moveTo(0, inside.height / 2);
  // ctxInside.lineTo(inside.width, inside.height / 2);
  // ctxInside.stroke();

  // First set the font and stuff, to make sure all measurements are correct
  ctxInside.fillStyle = "#333";
  ctxInside.textRendering = "optimizeLegibility";
  // ctxInside.font = "40pt Montserrat";
    const originalFont = "18mm Montserrat"
  ctxInside.font = originalFont;

  const lines = text.split("\n");

  const paragraphCount = lines.length;
  const lineDistance = 2;
  const maxWidth = 99 * toPixel - 3 * toPixel * 2; // 99mm - 3mm margin on each side

  const wordsPerLine: {
    words: Array<{ word: string; width: number }>;
    sumLength: number;
    paragraphEnd: boolean;
  }[] = [{ words: [], sumLength: 0, paragraphEnd: false }];
  let lineIndex = 0;

  const spaceMeasurement = ctxInside.measureText(" ");
  const lineHeight = spaceMeasurement.fontBoundingBoxAscent +
    spaceMeasurement.fontBoundingBoxDescent;

  for (let i = 0; i < paragraphCount; i++) {
    const words = lines[i].split(" ");
    const infos = words.map((word) => {
      let measuredWord = word;
      if (measuredWord.startsWith('_')) {
        ctxInside.font = toggleItalic(ctxInside.font, true);
        measuredWord = measuredWord.slice(1);
      }
      if (measuredWord.startsWith('*')) {
        ctxInside.font = toggleBold(ctxInside.font, true);
        measuredWord = measuredWord.slice(1);
      }
      if (measuredWord.endsWith('_')) {
        measuredWord = measuredWord.slice(0, -1);
      }
      if (measuredWord.endsWith('*')) {
        measuredWord = measuredWord.slice(0, -1);
      }

      const metrics = ctxInside.measureText(measuredWord);

      // Only toggle italic off after measuring the italic word.
      if (word.endsWith('_')) {
        ctxInside.font = toggleItalic(ctxInside.font, false);
      }
      if (word.endsWith('*')) {
        ctxInside.font = toggleBold(ctxInside.font, false);
      }
      return {
        word,
        width: metrics.width,
      };
    });

    // Fit as many words as possible in the line
    for (const info of infos) {
      // Does this word still fit?
      // If not, start a new line
      if (
        wordsPerLine[lineIndex].sumLength + info.width +
            wordsPerLine[lineIndex].words.length * spaceMeasurement.width >
          maxWidth
      ) {
        lineIndex++;
        if (wordsPerLine.length <= lineIndex) {
          wordsPerLine.push({ words: [], sumLength: 0, paragraphEnd: false });
        }
      }

      // Add the word to the current line
      wordsPerLine[lineIndex].words.push(info);
      wordsPerLine[lineIndex].sumLength += info.width;
    }

    // After every paragraph, we need to start a new line as well.
    wordsPerLine[lineIndex].paragraphEnd = true;
    lineIndex++;
    if (wordsPerLine.length <= lineIndex) {
      wordsPerLine.push({ words: [], sumLength: 0, paragraphEnd: false });
    }
  }

  // Reset Font after having processed italic
  ctxInside.font = originalFont;

  let line = 0;
  let bottomPartOffset = 0;

  for (const wordsInLine of wordsPerLine) {
    // Print all words in the line
    let x = mmPrintMargin + (columnIndex * 99 * toPixel);

    // Compute the amount of space between the words
    let marginBetweenWords = (maxWidth - wordsInLine.sumLength) /
      (wordsInLine.words.length - 1);

    // Special case: If we are the last line, the margin between words is the width of a space
    if (wordsInLine.paragraphEnd) {
      marginBetweenWords = spaceMeasurement.width;
    }

    // Special case: The "center" of the page is the fold line and therefore should be skipped
    let y = mmPrintMargin * 3 + (line * lineHeight) + (line * lineDistance) +
      bottomPartOffset;
    const safeY = inside.height / 2 + mmPrintMargin * 3;
    if (
      y > inside.height / 2 - mmPrintMargin &&
      y < safeY
    ) {
      bottomPartOffset = safeY - y;
      y = safeY;
    }

    for (const word of wordsInLine.words) {
      let renderedWord = word.word;
      if (renderedWord.startsWith('_')) {
          ctxInside.font = toggleItalic(ctxInside.font, true);
          renderedWord = renderedWord.slice(1);
      }
      if (renderedWord.endsWith('_')) {
          renderedWord = renderedWord.slice(0, -1);
      }
      if (renderedWord.startsWith('*')) {
          ctxInside.font = toggleBold(ctxInside.font, true);
          renderedWord = renderedWord.slice(1);
      }
      if (renderedWord.endsWith('*')) {
          renderedWord = renderedWord.slice(0, -1);
      }

      // Rotate the text we just wrote
      ctxInside.fillText(
          renderedWord,
        x,
        y,
      );
      x += word.width + marginBetweenWords;

      let parsedWord = word.word;
      if (parsedWord.endsWith('_')) {
          console.debug('removing italic', ctxInside.font)
        ctxInside.font = toggleItalic(ctxInside.font, false);
          console.debug('removed italic', ctxInside.font)
          parsedWord = parsedWord.slice(0, -1);
      }
      if (parsedWord.endsWith('*')) {
          console.debug('removing bold', ctxInside.font)
          ctxInside.font = toggleBold(ctxInside.font, false);
          console.debug('removed bold', ctxInside.font)
        parsedWord = parsedWord.slice(0, -1);
      }
    }

    line++; // move to the next line
  }
}
